module.exports = __webpack_public_path__ + "img/desk.a7250a42.jpg";